var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-view"},[(_vm.isToday)?[_c('span',[_vm._v(_vm._s(_vm.$t('common.today')))])]:[_c('span',[_vm._v(_vm._s(_vm.day))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.month))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }